import { ElementViewTemplate, html, slotted } from "@microsoft/fast-element";
import { CheckboxOptions, NatGenCheckbox } from "./checkbox";
import { staticallyCompose } from "../../foundation/template-helpers";

export function checkboxTemplate<T extends NatGenCheckbox>(options: CheckboxOptions = null) {
    return html<T>`
        <template
            role="checkbox"
            aria-checked="${x => (x.indeterminate ? "mixed" : x.checked)}"
            aria-required="${x => x.required}"
            aria-disabled="${x => x.disabled}"
            tabindex="${x => (x.disabled ? null : 0)}"
            @keydown="${(x, c) => x.keydownHandler(c.event as KeyboardEvent)}"
            @click="${(x, c) => x.clickHandler(c.event as MouseEvent)}"
        >
            <div part="control" class="control">
                <slot name="checked-indicator">
                    ${staticallyCompose(options?.checkedIndicator) || ""}
                </slot>
                <slot name="indeterminate-indicator">
                    ${staticallyCompose(options?.indeterminateIndicator) || ""}
                </slot>
            </div>
            <label
                part="label"
                class="${x =>
                    x.defaultSlottedNodes && x.defaultSlottedNodes.length
                        ? "label"
                        : "label label__hidden"}"
            >
                <slot ${slotted("defaultSlottedNodes")}></slot>
            </label>
        </template>
    `;
}
